<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions >
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-spacer></v-spacer>
                        <v-btn :loading="getingcache"
                               color="green"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onGetAssetCacheInfo">
                            get Asset Cache Info
                            <v-icon class="ml-2">mdi-cloud-download</v-icon>
                        </v-btn>
                        <v-btn :loading="caching"
                               color="orange"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onPressCacheAssets">
                            cache Assets
                            <v-icon class="ml-2">mdi-refresh</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions class="pt-0">
                <v-card width="100%" class="ma-0 pa-0" elevation="0">
                    <json-viewer
                            :expand-depth=10
                            v-if="jsonData != null"
                            copyable
                            :value="jsonData"></json-viewer>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import {CacheStoreUtils} from "@/modules/mcache/database/CacheStoreUtils";
import CacheStore from "@/modules/mcache/database/CacheStore";

export default {
    components: {},
    data: () => ({
        loading:true,
        caching:false,
        getingcache: false,
        message: "",
        jsonData: null,
    }),
    computed:{},
    methods: {
        onPressCacheAssets(){
            this.caching = true;
            CacheStoreUtils.cacheAssets()
                .then(() => {
                    this.caching = null
                    this.$notify({title: 'Assets cached!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.caching = null
                    this.$notify({title: 'Assets cache failed!', text: error, type: "error"});
                })
        },
        onGetAssetCacheInfo(){
            this.getingcache = true;
            CacheStoreUtils.getAssetCacheInfo()
                .then((data) => {
                    this.jsonData = data[0];
                    this.getingcache = null
                    this.$notify({title: 'Asset Cache Info!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.getingcache = null
                    this.$notify({title: 'Asset Cache Info failed!', text: error, type: "error"});
                })
        },
    },
    beforeMount() {
        this.loading = false
        this.$store.registerModule("cache-store", CacheStore);
        this.$store.dispatch("cache-store/init")
            .then(() => {
                console.log("Loaded successfully. cache-store");
            }).catch(() => {
            this.message = "Load failed!";
        }).finally(() => {
            this.loading = false;
        });
    },
    destroyed() {
        this.$store.unregisterModule("cache-store");
        console.log("destroy root view cache");
    }
}
</script>

<style scoped>
</style>